/* TWS Header — mobile "top sheet" (Option C). Static asset; drives every .twsh
   instance. Mobile accordions + icons are built from the live desktop nav so
   the mega-menu content is the single source of truth. */
(function () {
  function initHeader(root) {
    var nav = root.querySelector('nav.twsnav');
    var burger = root.querySelector('.burger');
    var scrim = root.querySelector('[data-scrim]');
    var sheet = root.querySelector('.sheet');
    if (!nav || !burger || !scrim || !sheet) return;
    var sheetBody = sheet.querySelector('.sheet-body');
    var body = document.body;

    function firstText(el) {
      var top = el.querySelector(':scope > .nav-top');   // Shop's label is a link
      if (top) return top.textContent.trim();
      var n = el.firstChild;
      return (n && n.nodeType === 3) ? n.textContent.trim() : el.textContent.trim();
    }

    root.querySelectorAll('.nav-links > .navitem').forEach(function (item) {
      var mega = item.querySelector('.mega');
      if (!mega) {
        var a = document.createElement('a');
        a.className = 'mlink';
        a.href = item.getAttribute('href') || '#';
        a.textContent = firstText(item);
        sheetBody.appendChild(a);
        return;
      }
      var acc = document.createElement('div'); acc.className = 'macc';
      var btn = document.createElement('button');
      btn.className = 'mtrigger'; btn.type = 'button'; btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span>' + firstText(item) + '</span><svg class="chev" viewBox="0 0 14 14"><path d="M3 5l4 4 4-4"/></svg>';
      var panel = document.createElement('div'); panel.className = 'mpanel';
      var pin = document.createElement('div'); pin.className = 'mpanel-in';
      mega.querySelectorAll('.col').forEach(function (col) {
        var c = document.createElement('div'); c.className = 'mcol';
        var h = col.querySelector('h5');
        if (h) { var mh = document.createElement('h5'); mh.textContent = h.textContent; c.appendChild(mh); }
        col.querySelectorAll('a').forEach(function (l) {
          var la = document.createElement('a'); la.href = l.getAttribute('href') || '#'; la.textContent = l.textContent; c.appendChild(la);
        });
        pin.appendChild(c);
      });
      panel.appendChild(pin); acc.appendChild(btn); acc.appendChild(panel);
      btn.addEventListener('click', function () {
        var willOpen = !acc.classList.contains('open');
        sheetBody.querySelectorAll('.macc.open').forEach(function (o) {
          o.classList.remove('open');
          o.querySelector('.mpanel').style.maxHeight = '0px';
          o.querySelector('.mtrigger').setAttribute('aria-expanded', 'false');
        });
        if (willOpen) { acc.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); panel.style.maxHeight = pin.scrollHeight + 'px'; }
      });
      sheetBody.appendChild(acc);
    });

    // Desktop: flag <body> while any mega-menu is hovered open, so the meta-bar
    // strip can hide itself (body.twsh-mega-open). :hover is read live so moving
    // between adjacent megas or onto a plain item resolves correctly, no flicker.
    var navLinks = root.querySelector('.nav-links');
    if (navLinks) {
      var syncMega = function () {
        body.classList.toggle('twsh-mega-open', !!navLinks.querySelector('.has-mega:hover, .has-mega.is-open'));
      };
      navLinks.addEventListener('mouseover', syncMega);
      navLinks.addEventListener('mouseout', syncMega);

      // ---- Desktop mega-menu: hold it open ----
      // The panel was pure CSS :hover. The trigger is only the label; below it
      // sits the nav's own padding, which belongs to neither the label nor the
      // panel — so moving diagonally rather than straight down crossed dead
      // ground, :hover flipped, and the menu shut mid-movement.
      //
      // pointerenter/pointerleave on .has-mega already treat the panel as part
      // of the item (it is a DOM descendant, wherever it is painted), so the only
      // thing missing was tolerance for that dead ground: leaving starts a short
      // timer, re-entering cancels it. CSS still opens on :hover, so with JS off
      // the original behaviour survives.
      var GRACE = 260, holdTimer = null, holdOpen = null;
      var megaItems = navLinks.querySelectorAll('.navitem.has-mega');
      var cancelHold = function () { if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; } };
      var shutItem = function (item) {
        if (item) item.classList.remove('is-open');
        if (holdOpen === item) holdOpen = null;
        syncMega();
      };
      Array.prototype.forEach.call(megaItems, function (item) {
        item.addEventListener('pointerenter', function () {
          cancelHold();
          if (holdOpen && holdOpen !== item) shutItem(holdOpen);   // switching is instant
          item.classList.add('is-open');
          holdOpen = item;
          syncMega();
        });
        item.addEventListener('pointerleave', function () {
          cancelHold();
          holdTimer = setTimeout(function () { shutItem(item); holdTimer = null; }, GRACE);
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          cancelHold();
          Array.prototype.forEach.call(megaItems, function (i) { i.classList.remove('is-open'); });
          holdOpen = null;
          syncMega();
        }
      });

    }

    var ico = root.querySelector('.nav-ico');
    if (ico) sheetBody.appendChild(ico.cloneNode(true));

    function clearHeader() { sheetBody.style.paddingTop = (nav.getBoundingClientRect().bottom + 10) + 'px'; }
    clearHeader();
    window.addEventListener('resize', clearHeader, { passive: true });

    function openM() {
      clearHeader();
      root.classList.add('nav-open'); body.classList.add('twsh-locked');
      burger.setAttribute('aria-expanded', 'true'); burger.setAttribute('aria-label', 'Close menu');
    }
    function closeM() {
      root.classList.remove('nav-open'); body.classList.remove('twsh-locked');
      burger.setAttribute('aria-expanded', 'false'); burger.setAttribute('aria-label', 'Open menu');
      sheet.querySelectorAll('.macc.open').forEach(function (a) {
        a.classList.remove('open');
        a.querySelector('.mpanel').style.maxHeight = '0px';
        a.querySelector('.mtrigger').setAttribute('aria-expanded', 'false');
      });
    }
    burger.addEventListener('click', function () { root.classList.contains('nav-open') ? closeM() : openM(); });
    scrim.addEventListener('click', closeM);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeM(); });
    sheetBody.addEventListener('click', function (e) { if (e.target.closest('a')) closeM(); });
  }

  function boot() { document.querySelectorAll('.twsh').forEach(initHeader); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
